module.exports = __webpack_public_path__ + "media/country_flags/bs-d123b757.png";